import { privateApi } from '@services/api';
import { IConversationList } from '@company/types/conversation.type';
import Messages from '@th-types/messages.type';
import MessageRequest from '@th-types/message-request.type';
import IResultResponse from '@th-types/resultResponse.type';
import pLimit from 'p-limit';

export const MAIN_URL = 'chat';

export const fetchConversations = async (
  jobId: number | undefined,
  conversationNameFilter: string | null
) => {
  if (jobId === undefined) {
    return Promise.reject(new Error('No job id was passed'));
  }
  const url = `company/${MAIN_URL}/job-chats/${jobId}`;
  const params: Record<string, string> = {
    max: '999',
  };
  if (conversationNameFilter) {
    params.filter = conversationNameFilter;
  }

  try {
    const result = await privateApi.get<IConversationList>(url, { params });
    return result.data;
  } catch (error) {
    console.log('Occurred an error trying to retrieve the conversation');
    return Promise.reject(error);
  }
};

export const fetchMessages = async (jobChatId: number | null | undefined) => {
  if (!jobChatId) {
    return Promise.resolve({} as Messages);
  }

  const url = `${MAIN_URL}/job-chats/${jobChatId}/messages`;
  try {
    const result = await privateApi.get<Messages>(url);
    return result.data;
  } catch (error) {
    console.log(
      `Occurred an error trying to fetch messages for conversation ${jobChatId}`
    );
    return Promise.reject(error);
  }
};

export const sendMessage = async (
  jobChatId: number | null,
  message: MessageRequest
) => {
  try {
    const result = await privateApi.post<IResultResponse>(
      `${MAIN_URL}/job-chats/${jobChatId}/send`,
      message
    );
    return result.data;
  } catch (error: any) {
    const errorMessage = error?.message ?? 'Error while sending message';
    console.error(
      `Occurred an error trying to send a message with errorMessage:'${errorMessage}' for \njobChatId: ${jobChatId}`
    );
    return { message: errorMessage, success: false };
  }
};

export const readMessages = async (jobChatId: number) => {
  const result = await privateApi
    .post<IResultResponse>(`${MAIN_URL}/job-chats/${jobChatId}/read`)
    .catch((error) => {
      console.log('Occurred an error trying to read the conversation');
      return error.response;
    });
  return result.data;
};

export const unreadMessages = async (jobChatId: number) => {
  const result = await privateApi
    .post<IResultResponse>(`${MAIN_URL}/job-chats/${jobChatId}/unread`)
    .catch((error) => {
      console.log('Occurred an error trying to unread the conversation');

      return error.response;
    });
  return result.data;
};

export const batchReadMessages = async (jobChatIds: number[]) => {
  const limit = pLimit(2);

  const results = await Promise.all(
    jobChatIds.map((jobChatId) =>
      limit(async () => {
        try {
          const result = await privateApi.post<IResultResponse>(
            `${MAIN_URL}/job-chats/${jobChatId}/read`
          );
          return { jobChatId, success: true, data: result.data };
        } catch (error) {
          console.log(`Error reading conversation ${jobChatId}:`, error);
          return { jobChatId, success: false, error };
        }
      })
    )
  );
  return results;
};
